import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { HTTPService } from 'src/app/services/http.service';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { FormulaTesterComponent, Variable } from 'src/app/forms/formula-tester/formula-tester.component';
import { DialogService } from 'src/app/services/dialog.service';
import { FormBuilder } from '@angular/forms';
import { CdkDragDrop, CdkDragEnd, moveItemInArray } from '@angular/cdk/drag-drop'; // Importe o módulo do CDK de arrastar e soltar
import { Observable } from 'rxjs';
import {map, startWith} from 'rxjs/operators';




export interface DialogData {
  entity: any;
  idInstance: any,
  instanceName:any,
  dpara: any;

  
}

interface Food {
  value: string;
  viewValue: string;
}

interface Table {
  name: string;
  columns: string[];
}

interface JsonField {
  name: string;
  column: string;
}

interface Mapping {
  jsonKey: string;
  table: string;
  column: string;
}

interface JsonKey {
  name: string;
  mapping: string | null;
}



@Component({
    selector: 'app-dparamodal-json',
    templateUrl: './json-config.component.html',
    styleUrls: ['./json-config.component.scss'],
    standalone: false
})
export class JsonConfigComponent implements OnInit {
  displayedColumns: string[] = ['desc', 'field', 'type', 'key',  'dpara', 'df'];  
  foods: Food[] = [
    {value: 'steak-0', viewValue: 'Steak'},
    {value: 'pizza-1', viewValue: 'Pizza'},
    {value: 'tacos-2', viewValue: 'Tacos'},
  ];
  formGroupJson: FormGroup;
  dataSource: any;
  columns: any[] = [];
  dates:Object = null;
  variables:Variable[] = [];
  loading = true;
  formula:string;
  isJSON: boolean = true;
  hasHeader: boolean = true;
  hasUpdate: boolean = false;
  token:string;
  url:string;
  headerLineNumber: any = 0;
  formHeader: FormGroup;
  jsonFields: JsonField[] = [];
  customJson:any;
  tokenHeight: number = 25;
  customJsonFields: any[];
  parameterType;
  filteredColumns: any[] = [];
  columnSearchControl = new FormControl();
  dparaValue:any;
  filteredFields: any[] = []; 
  searchField: string = '';
  showLoading:boolean = true;
  filteredOptions: Observable<string[]>;
  myControl = new FormControl('');
  originalColumns: any[] = [];
  filteredColumnsMap: { [key: string]: any[] } = {};
  draggedColumn: string | null = null;



  tables: Table[] = [
    {
      name: 'Pessoal',
      columns: ['nome', 'idade']
    },
    {
      name: 'Endereço',
      columns: ['rua', 'cidade', 'estado']
    },
    {
      name: 'Emprego',
      columns: ['empresa', 'cargo']
    }
  ];

  mappings: Mapping[] = [];

  jsonKeys: JsonKey[] = [
    { name: 'Key 1', mapping: null },
    { name: 'Key 2', mapping: null },
    { name: 'Key 3', mapping: null },
    { name: 'Key 4', mapping: null },
    { name: 'Key 5', mapping: null },
    { name: 'Key 6', mapping: null },
  ];


  
  constructor(
    public dialogRef: NzModalRef<JsonConfigComponent>,
    @Inject(NZ_MODAL_DATA) public data: DialogData, private http:HTTPService, private cdr:ChangeDetectorRef, private dialogServices:DialogService, private fb: FormBuilder) {      
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onColumnSelect(event): void {
    const filterValue = event.value.toLowerCase();
    this.filteredColumns = this.columns.filter(column =>
      column.COLUMNNAME.toLowerCase().includes(filterValue)
    );
  }
  drop(event: CdkDragDrop<any[]>, targetKey: JsonKey) {
    const sourceContainerId = event.previousContainer?.id;
    const targetContainerId = event.container?.id;
  
    if (sourceContainerId === 'table-cards' && targetContainerId?.startsWith('json')) {
      const targetKeyName = targetContainerId.substring('json-'.length);
      const columnName = event.item.data;
  
      const targetKey = this.jsonKeys.find((key: JsonKey) => key.name === targetKeyName);
      if (targetKey) {
        targetKey.mapping = `${targetKeyName}.${columnName}`;
      }
    } else if (sourceContainerId?.startsWith('json') && targetContainerId === 'table-cards') {
      const sourceKeyName = sourceContainerId.substring('json-'.length);
      const columnName = event.item.data;
  
      const targetTable = this.tables.find((table: Table) => table.name === columnName);
      if (targetTable) {
        targetTable.columns.push(columnName);
      }
  
      const sourceKey = this.jsonKeys.find((key: JsonKey) => key.name === sourceKeyName);
      if (sourceKey) {
        sourceKey.mapping = null;
      }
    }
  }

  dragEnded(event: CdkDragEnd, data: any, container: ElementRef) {
    const { x, y } = event.source.getRootElement().getBoundingClientRect();
    const containerRect = container.nativeElement.getBoundingClientRect();
  
    if (x >= containerRect.left && x <= containerRect.right && y >= containerRect.top && y <= containerRect.bottom) {
      
      if (container.nativeElement.id.startsWith('json')) {
       
        const targetKeyName = container.nativeElement.id.substring('json-'.length);
  
       
        const targetKey = this.jsonKeys.find((key: JsonKey) => key.name === targetKeyName);
        if (targetKey) {
          targetKey.mapping = `${targetKeyName}.${data}`;
        }
      } else if (container.nativeElement.id === 'table-cards') {       
        const columnName = data;  
       
        const targetTable = this.tables.find((table: Table) => table.name === columnName);
        if (targetTable) {
          targetTable.columns.push(columnName);
        }
      }
    }
  }
  
  setDraggedColumn(column: string) {
    this.draggedColumn = column;
  }




  removeTable(index: number) {
    this.tables.splice(index, 1);
  }
  
  
  removeMapping(index: number) {
    this.mappings.splice(index, 1);
  }


  ngOnInit(): void { 
    
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );

   

    
    this.formGroupJson = this.fb.group({});
    this.formGroupJson.addControl("envavar",new FormControl({value:null,disabled:true})); 

    let obinfo = {
      "entityName":"Mktpdiccol",
      "sql":`SELECT COLUMNNAME, DATATYPE, COLUMNDESC, ISPK, COLSIZE FROM Mktpdiccol (nolock) WHERE IDINSTANCE=${this.data.idInstance} ORDER BY ISPK DESC,COLUMNNAME`
    }         

    
    this.hasHeader = true;
    this.headerLineNumber = 0;
    this.hasUpdate = false;
    this.isJSON = true;
    this.url = "";
    this.token = "";
    this.showLoading = true;
    
    
    
    this.http.post(obinfo,'JsonBrokerServices/findnative',false,true,true).subscribe(conInfo=>{
      let info =  conInfo['SQL'];
      this.columns = info.map(column => ({ ...column, dparaValue: '', formula: ''}));
      
      this.originalColumns = [...this.columns];


      this.loading = false;
      this.cdr.detectChanges(); 
    });
      
  }

  _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
  
    return this.originalColumns.filter(option => option['COLUMNNAME'].toLowerCase().includes(filterValue));
  }

  resetFilter(): void {
    this.filteredColumns = [...this.originalColumns];
  }

  filterFields(): void {
    this.showLoading = true;

    this.filteredFields = this.customJsonFields.filter((field) =>
      field.key.toLowerCase().includes(this.searchField.toLowerCase())
    );

    this.showLoading = false;

  }

  getFieldControl(field: any): AbstractControl {
    return this.formGroupJson.get(`customJsonFieldsGroup.${this.customJsonFields.indexOf(field)}.dparaValue`);
  }

   updateFieldMapping(field: any, event:any): void {    
    field.dparaValue = event.option.value;    
    this.resetFilter();
  }
  
  parseCustomJson() {
    try {
      const parsedJson = JSON.parse(this.customJson);
  
      
      this.customJsonFields = [];
  
     
      this.processJsonFields(parsedJson, '');
      this.filterFields();

      this.filteredColumnsMap = {};
      
      for (const field of this.customJsonFields) {
        this.filteredColumnsMap[field.key] = [...this.columns];
      }
  
      
      console.log('Campos personalizados:', this.customJsonFields);
    } catch (error) {
      
      console.error('Erro ao analisar o JSON personalizado:', error);
    }
  }
  

  processJsonFields(jsonObj: any, prefix: string) {
    this.showLoading = true;
  
    for (const key in jsonObj) {
      if (jsonObj.hasOwnProperty(key)) {
        const value = jsonObj[key];
  
        if (Array.isArray(value)) {
          
          if (value.length > 0 && typeof value[0] === 'object') {
            
            value.forEach((obj, index) => {
              const fieldPrefix = `${prefix}${key}[${index}].`;
  
              
              this.processJsonFields(obj, fieldPrefix);
            });
          } else {
            const field = {
              key: prefix + key,
              value: value,
              columnName: '', 
              dataType: '', 
              dparaValue: '', 
              formula: ''
            };
  
            
            const matchingColumn = this.columns.find(column => column.column === key);
            if (matchingColumn) {
              field.columnName = matchingColumn.columnName;
              field.dataType = matchingColumn.dataType;
            }
  
            this.customJsonFields.push(field);
          }
        } else if (typeof value === 'object') {
          this.processJsonFields(value, prefix + key + '.');
        } else {
          const field = {
            key: prefix + key,
            value: value,
            columnName: '', 
            dataType: '', 
            dparaValue: '',
            formula: '' 
          };
  
          
          const matchingColumn = this.columns.find(column => column.column === key);
          if (matchingColumn) {
            field.columnName = matchingColumn.columnName;
            field.dataType = matchingColumn.dataType;
          }
  
          this.customJsonFields.push(field);
        }
      }
    }
  
    this.showLoading = false;
  }
  

  generatePrefix(index: number): string {
    const prefix = 'field_';
    return prefix + index.toString();
  }

  loadJsonFromEndpoint(): void {
   
    /*this.http.get(this.url, this.token).subscribe((json) => {
      this.customJson = JSON.stringify(json);
    });*/
  }

  openEditFormula(column){
    this.variables = [];    

    this.dialogServices.openGenericDialog(FormulaTesterComponent,{formula:this.formula, variables:this.variables},(f)=>{
        if ( f['formula']){
          column.formula = f['formula'];
        }
        
    },()=>{},'80vh','80vw',false,null,'S','80px');
  }

  dropJsonField(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.customJsonFields, event.previousIndex, event.currentIndex);
  }

  dropColumn(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
  }

  onDatabaseColumnDrop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
  }

  onJsonFieldDrop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.customJsonFields, event.previousIndex, event.currentIndex);
  }

}
